
import { Chart, registerables } from "chart.js";
import { enUS } from "date-fns/locale";

export class ChartJsAverageTemperatureGraph {

    graph: Chart;

    constructor(){}

    draw(data: any[]){

        let xValues = [];
        let yValues = [];

        for(let i in data){
            let dataPoint = data[i];
            // let date = new Date(dataPoint.timestamp);
            xValues.push(dataPoint.timestamp);
            yValues.push(dataPoint.value/10);
        }

        Chart.register(...registerables);

        this.graph = new Chart('averageTemp', {
            type: 'line',
            data: {
                labels: xValues,
                datasets: [{
                    label: 'Temperature',
                    data: yValues,
                    backgroundColor: 'orange',
                    borderColor: 'orange',
                    borderWidth: 1,
                    pointRadius: 0,
                    

                },
                ]

            }
            ,
            options: {
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        display: true,
                        text: 'Temperature'
                    },
                    tooltip: {
                        callbacks: {
                            footer: (point) => {

                            },
                            label: (point) => {
                                let value = point.parsed.y;
                                return value + " °C";
                            }
                        }
                    }
                },
                scales: {
                    y: {
                        ticks: {
                            callback: (value, index, values) => {
                                return value + '°C';
                            }
                        }

                    },
                    x: {

                        type: 'time',
                        adapters: {
                          date: {
                            locale: enUS
                          },

                        },
                        time: {
                            unit: 'day',
                        },
                        ticks: {
                            callback: (value) => {
                                const date = new Date(value);
                                const dayOfWeek = date.getDay();

                                let dayOfWeekString;

                                switch (dayOfWeek){
                                    case 1:
                                        dayOfWeekString = 'Mon';
                                        break;
                                    case 2:
                                        dayOfWeekString = 'Tue';
                                        break;
                                    case 3:
                                        dayOfWeekString = 'Wed';
                                        break;
                                    case 4:
                                        dayOfWeekString = 'Thu';
                                        break;
                                    case 5:
                                        dayOfWeekString = 'Fri';
                                        break;
                                    case 6:
                                        dayOfWeekString = 'Sat';
                                        break;
                                    case 0:
                                        dayOfWeekString = 'Sun';
                                        break;
                                }

                                const dayOfMonth = date.getDate();

                                return dayOfWeekString + ' '  + dayOfMonth;
                            }

                        }
                    }
                }

            }
        }
        );

    }

}
